<!--版本資訊-->
<template>
    <v-layout xs12 sm12 md12 lg12>

        <v-flex mx-2 px-2 >
            <span style="text-decoration: underline;">版本資訊 </span>
            <br/>   <span style="cursor: pointer" @click="openMaintain"> 前端版本號: {{this.$store.state.AppSetting.versionFront}} </span>
            <br/>   <span style="cursor: pointer" @click="openMaintain"> 後端版本號: {{versionName}}</span>
        </v-flex>

        <!-- 我是 snackbar -->
        <v-snackbar
                top
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>

        <v-dialog v-model="passDialog"
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  persistent
                  scrollable>

            <v-card class="cardBgColorStyle" >

                <v-toolbar dark dense color="tertiary">
                    <v-toolbar-title> 輸入使用者代號和維護密碼 </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn title="關閉視窗" icon dark @click.native="passDialog=false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                </v-toolbar>

                <v-card-text>
                    <v-container grid-list-md style="padding: 0px!important;">

                            <v-form >

                                <v-text-field prepend-icon="mdi-account"
                                              ref="userId"
                                              v-model="userId"
                                              name="login"
                                              label="使用者代號"
                                              type="text"
                                              :rules="[value => !!value || '請輸入使用者代號']"
                                              @keyup.enter="NextItem('password')"
                                ></v-text-field>


                                <v-text-field ref="password" id="password" prepend-icon="mdi-lock" v-model="password" name="password" label="輸入密碼"
                                              @keyup.enter="btnPass"
                                              :append-icon="showOld ? 'mdi-eye-off' : 'mdi-eye'"
                                              :type="showOld ? 'text' : 'password'"
                                              @click:append="showOld = !showOld"
                                              :rules="[value => !!value || '請輸入密碼']"
                                ></v-text-field>

                                <!--<v-flex xs12 sm12 md12 d-inline-flex>-->
                                <!--<v-flex xs3 sm3 md2 text-right  class="labelFont">-->
                                <!--<v-label >輸入密碼</v-label>-->
                                <!--</v-flex>-->
                                <!--<v-flex xs9 sm9 md10 pl-2>-->
                                <!--<v-text-field ref="password" type="password" v-model="password"  clearable @keyup.enter="btnPass"></v-text-field>-->
                                <!--</v-flex>-->
                                <!--</v-flex>-->

                            </v-form>

                        <v-alert :value="showError" type="error">
                            <span v-html="errmsg"></span>
                            <!--{{message}}-->
                        </v-alert>
                    </v-container>
                </v-card-text>
                <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
                    <v-spacer></v-spacer>
                    <v-btn  @click.native="passDialog=false">取消</v-btn>
                    <v-btn  @click.native="btnPass">確定</v-btn>
                </v-card-actions>

                <!-- 我是 snackbar -->
                <v-snackbar
                        :timeout="snTimeout"
                        v-model="snStatus">
                    {{snText}}
                </v-snackbar>


            </v-card>

        </v-dialog>

    </v-layout>
</template>

<script>
    import {EventBus} from '../../../js/event-bus'
    export default {
        name: "VersionInfoSimple",
        data() {
            return {
                showOld:false,
                userId:'',
                versionName:'',
                count: 0,
                snTimeout:3000,
                snStatus:false,
                snText:'',
                mainPass:'max72574',//管理者pwd
                passDialog:false,
                password:'',
                showError:false,
                errmsg:'',
                mainPassList:[],

            }
        },
        created(){
            this.axios_getRegSetMainPass();
            this.axios_getBackVersonName();//取得後端目前版號
        },
        computed:{
            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  50}
                if(this.$vuetify.breakpoint.xl ==true){width =  40}
                return width
            },
        },
        methods:{
            findMaintainUser(userId,password){
                return this.mainPassList.filter((i) => {
                    return (i.value1==userId&&i.value2==password) ;
                })
            },
            NextItem:function(id) {
                this.$refs[id].focus();
            },
            btnPass(){ //110/08/18 多傳入為何種維護模式 密碼等於設定檔 為 Y U; 密碼等於公司 為 Y U M
                let postMaintainLog =  {
                    rawPk: null,
                    createDatetime: null,
                    userId: this.userId,
                    operType: "LOGIN",
                    operTarget: "IREGSYS",
                    logMemo: "",
                }
                if((this.userId!==''&&this.userId!==null)&&(this.password!==''&&this.password!==null)){
                    let userPass = this.findMaintainUser(this.userId,this.password);
                    if((this.userId=='hismax'&&this.password==this.mainPass)){ //SUCCESS
                        EventBus.$emit('open-maintain',10,this.password==this.mainPass?'M':'U');
                        this.passDialog = false;
                        this.snStatus = true;
                        this.snText = '開啟維護模式'
                        this.showError = false;
                        postMaintainLog.logMemo = 'SUCCESS';
                        this.axios_postMaintainLog(postMaintainLog);
                    }else if(userPass.length>0){ //SUCCESS
                        EventBus.$emit('open-maintain',10,this.password==this.mainPass?'M':'U');
                        this.passDialog = false;
                        this.snStatus = true;
                        this.snText = '開啟維護模式'
                        this.showError = false;
                        postMaintainLog.logMemo = 'SUCCESS';
                        this.axios_postMaintainLog(postMaintainLog);
                    }else { //FAIL
                        this.showError = true;
                        this.errmsg = '帳號或密碼輸入錯誤 請確認是否輸入正確'
                        postMaintainLog.logMemo = 'FAIL';
                        this.axios_postMaintainLog(postMaintainLog);
                        return;
                    }
                }else {
                    this.showError = true;
                    this.errmsg = '請確認是否 輸入使用者代號和密碼'
                    return;
                }


                /** if(this.password=='max72574'||this.password==this.mainPass){
                    EventBus.$emit('open-maintain',10,this.password==this.mainPass?'U':'M');
                    this.passDialog = false;
                    this.snStatus = true;
                    this.snText = '開啟維護模式'
                }else {
                    this.showError = true;
                    this.errmsg = '密碼錯誤';
                }***/

            },
            openMaintain(){
                this.count++;
                // this.snText = '目前點了'+this.count+"下"
                if(this.count>10||this.count==10){
                    this.snStatus = true;
                    if(this.mainPass==''){
                        EventBus.$emit('open-maintain', this.count);
                        this.snText = '已點擊10下,開啟維護模式';
                    }else {
                        this.snText = '已點擊10下';
                        this.passDialog = true;
                        this.errmsg = '';
                        this.showError = false;
                    }

                }

            },
            axios_getRegSetMainPass (){ // MAINTAIN_PASS 開啟維護程式 密碼
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/MAINTAIN_PASS";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.mainPassList = response.data.resultSet;
                    }else {
                        this.mainPassList = [];
                    }

                }).catch(error =>  {
                    this.mainPassList = [];
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.response.data.status);
                    }
                });
            },
            axios_getBackVersonName (){ //取得後端版本號
                this.versionName = '';
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "config/versionnumber";


                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.versionName = response.data.resultSet[0].value;
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.versionName = '';
                    } catch(err) {
                        this.versionName = '';
                    }
                });
            },
            axios_postMaintainLog(postData){ //新增 掛號說明
                let postList = [];
                postList.push(postData);
                let url = this.$store.state.AppSetting.backSrvUrl+'maintainlog/';

                this.$http.post(url,postList).then(response=>{
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.snStatus=true;
                        this.snText = "寫入使用者記錄 "+response.data.message;
                        let  loginUser = {
                            userId:postData.userId,
                            loginTime:this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'showDT')
                        }
                        this.$store.commit('loginProc', loginUser);
                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
        },
        // beforeDestroy(){
        //     EventBus.$off('open-maintain');
        // },
    }
</script>

<style scoped>

</style>